import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InspectorControls,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        TextControl,
        SelectControl,
    } = window.wp.components;

    registerBlockType('custom-gutenberg/content-with-icon', {
        // built-in attributes
        title: 'Content With Icon',
        description: 'Content With Icon',
        icon: '',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            title: {
                type: 'string',
                default: '',
            },
            description: {
                type: 'string',
                default: '',
            },
            collapseId: {
                type: 'string',
                default: ''
            }, 
            icon: {
                type: 'string',
                default: 'person-swimming.png'
            },
            iconClass: {
                type: 'string',
                default: ''
            }
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                title,
                description,
                icon,
                iconClass,
                classes
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>

                        <p><strong>Title:</strong></p>
                        <TextControl value={ title } onChange={( title ) => setAttributes({ title }) }></TextControl>
                        <br />
                        <p><strong>Description:</strong></p>
                        <TextControl value={ description } onChange={( description ) => setAttributes({ description }) }></TextControl>
                        <br />
                        <p><strong>Icon class:</strong></p>
                        <TextControl value={ iconClass } onChange={( iconClass ) => setAttributes({ iconClass }) }></TextControl>
                        <br />
                        <p><strong>Icon</strong></p>
                        <SelectControl
                            label="Icon"
                            value={icon}
                            options={ [
                                {
                                    value: 'person-swimming.png',
                                    label: 'Person swimming',
                                },
                                {
                                    value: 'cards.png',
                                    label: 'Cards',
                                },
                                {
                                    value: 'plate-utensils.png',
                                    label: 'Plate utensils',
                                },
                            ]}
                            onChange={ ( icon ) => setAttributes({ icon }) }
                        />
                    </PanelBody>
                </InspectorControls>
                ,
                <div className="content-with-icon-wrapper">
                    <div className="card-body">
                        <h6 className="card-title">{ title }</h6>
                        <p className="content">
                            { description }
                        </p>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                title,
                description,
                icon,
                iconClass,
                classes
            } = attributes;

            return (
                <div className={"content-with-icon-wrapper " + (classes ? classes : '')}>
                    <img src={`/wp-content/uploads/${icon}`} className={iconClass} alt={`${ title } icon`} />
                    <div className="card-body">
                        <h6 className="card-title">{ title }</h6>
                        <p className="content"> { description } </p>
                    </div>
                </div>
            );
        },
    });
}